import { Injectable, signal } from '@angular/core';
import { ICommunity } from '../../interfaces/community.interface';

@Injectable({
  providedIn: 'root',
})
export class CommunitySignalService {
  community = signal<ICommunity | undefined>(undefined);
  private isValidCommunityUser = signal<boolean>(false);
  private previousPage: string | null = null;
  private previousTab!: string ;
  private previousCampaignTypeTab: string = '';
  private $communityId = signal<number>(0);

  setCommunity(community: ICommunity) {
    this.community.set(community);
  }

  getCommunity(): ICommunity | undefined {
    return this.community();
  }

  public set signalCommunityId(value) {
    this.$communityId = value;
  }
  public get signalCommunityId() {
    return this.$communityId;
  }

  public set signalIsValidCommunityUser(value) {
    this.isValidCommunityUser = value;
  }

  public get signalIsValidCommunityUser() {
    return this.isValidCommunityUser;
  }

  public setPreviousPage(page: string) {
    this.previousPage = page;
  }

  public getPreviousPage(): string | null {
    return this.previousPage;
  }

  public clearPreviousPage() {
    this.previousPage = null;
  }

  public setPreviousTab(page: string) {
    this.previousTab = page;
  }

  public getPreviousTab(): string {
    return this.previousTab;
  }

  public clearPreviousTab() {
    this.previousTab = '';
  }

  public setCampaignTypeTab(page: string) {
    this.previousCampaignTypeTab = page;
  }

  public getCampaignTypeTab(): string {
    return this.previousCampaignTypeTab;
  }

  public clearCampaignTypeTab() {
    this.previousCampaignTypeTab = '';
  }
}
